import { Payment } from 'src/models/payment';
import { FC } from 'react';
import { Lesson } from 'src/models/lesson';
import { Tutor } from 'src/models/tutor';
import Chart from 'react-apexcharts';
import { Box, Card, CardContent, Container, useTheme } from '@mui/material';
import { ApexOptions } from 'apexcharts';
import { getWeekNumber } from 'src/tools/dateTools';



interface TableProps {
  lessons: Lesson[];
  tutors: Tutor[];
  stacked: boolean;
}

const WeeklyTutorHours: FC<TableProps> = ({ lessons: lessons,tutors:tutors,stacked:stacked }) => {
  const theme = useTheme();

  function generateWeekNumbers(X: number): string[] {
    const result: string[] = [];
    for (let i = 1; i <= X; i++) {
      result.push(i.toString());
    }
    return result;
  }

  const chartOptions: ApexOptions = {
    chart: {
      background: 'transparent',
      type: 'area',
      stacked: stacked,
      foreColor: '#fff',
      toolbar: {
        show: false
      },

      zoom: {
        enabled: false
      }
    },
    fill: {
      gradient: {
        shade: 'light',
        type: 'vertical',
        shadeIntensity: 0.1,
        inverseColors: false,
        opacityFrom: 0.8,
        opacityTo: 0,
        stops: [0, 100]
      }
    },
    colors: [theme.colors.primary.main, 'white', 'blue','green'],
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      colors: [theme.colors.primary.main, 'white', 'blue','green'],
      width: 3
    },
    legend: {
      show: true,
      onItemHover: {
        highlightDataSeries: true
      },
    },
    labels: generateWeekNumbers(getWeekNumber(new Date())),

    xaxis: {
      labels: {
        show: true,
        style: {
          colors: '#ffffff',
        },
      },

      axisBorder: {
        show: true
      },
      axisTicks: {
        show: true
      }
    },
    yaxis: {
      min: 0,
      labels: {
        style: {
          colors: '#ffffff',
        },
      },
      show: true,
      tickAmount: 5
    },
    tooltip: {
      theme: 'dark',
      marker: {
        show: true,
      },
    },

  };

  function initializeDictionary(maxKey: number): Record<number, number> {
    const dictionary: Record<number, number> = {};

    for (let i = 1; i <= maxKey; i++) {
      dictionary[i] = 0;
    }

    return dictionary;
  }


  const GetWeeklyIncome = (filteredLessons: Lesson[]): [number, number][] => {
    const currentWeek = getWeekNumber(new Date());

    const weekDict: Record<number, number> = initializeDictionary(currentWeek);

    filteredLessons.forEach((lesson) => {
      const paymentDate = new Date(lesson.date);
      const weekNumber = getWeekNumber(paymentDate);

      if (weekNumber in weekDict) {
        weekDict[weekNumber] += lesson.duration;
      }
    });

    // Convert to an array and sort by week number
    const sortedWeekArray = Object.entries(weekDict).map(([weekNumber, amount]) => [
      parseInt(weekNumber, 10),
      amount,
    ]).sort((a, b) => a[0] - b[0]) as [number, number][];

    return sortedWeekArray;
  };

  const chartData = tutors.map(tutor => ({
    name: tutor.first_name + " " + tutor.last_name,
    data: GetWeeklyIncome(lessons.filter(lesson => lesson.status == 'completed' && lesson.tutor._id == tutor._id))
  }));

  return (
    <>
      <Card>
        <CardContent >
          <Box >
            <h2>{stacked?'Tutor Hours':'Tutor Hours Stacked'}</h2>

              <Chart
                options={chartOptions}
                series={chartData}
                type="area"
                height={300}
              />
          </Box>

        </CardContent>
      </Card>
    </>
  );
};


export default WeeklyTutorHours;
